// @flow
const supportContributeURL = 'https://support.theguardian.com/contribute';
const supportSubscribeURL = 'https://support.theguardian.com/subscribe';

export { supportContributeURL, supportSubscribeURL };
